import SearchIcon from './Search/Search.component';
import UserIcon from './User/User.component';

export default { SearchIcon, UserIcon };
